module.exports = __webpack_public_path__ + "static/5-52ab81b3ccd2101443c251f0ad3a1b91.jpg";